"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/InterfaceSearch` instead */
export const InterfaceSearch = createSVGIcon(
  <path
    d="M7.28.85H2.6C1.633.85.85 1.632.85 2.599V7.28M.85 16.72v4.68c0 .967.783 1.75 1.75 1.75h4.68M16.72.85h4.68c.967 0 1.75.783 1.75 1.75v4.68M23.15 16.72v4.681a1.75 1.75 0 0 1-1.75 1.75h-4.68M14.177 14.17a4.29 4.29 0 1 0-6.073-6.06 4.29 4.29 0 0 0 6.073 6.06Zm0 0 2.973 2.98"
    stroke="currentColor"
    strokeLinecap="round"
  />,
  "InterfaceSearch",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
